import axios from 'axios';
import AppConfig from 'app-config';
import { authError, AuthError } from './errors';

const transport = axios.create({
  baseURL: AppConfig.AuthMSBaseUrl,
  withCredentials: true,
  timeout: 15000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Application': 'pbb'
  }
});

export async function authRequest<T>(
  path: string,
  body?: unknown,
  options: {
    method?: 'GET' | 'POST';
    csrf?: string;
    token?: string;
  } = {}
): Promise<T> {
  if (!AppConfig.AuthMSBaseUrl) throw new AuthError('Authentication URL is not configured.', 503);
  try {
    const response = await transport.request<T>({
      url: path,
      method: options.method || 'POST',
      data: body,
      headers: {
        ...(options.csrf ? { 'X-CSRF-Token': options.csrf } : {}),
        ...(options.token ? { Authorization: `Bearer ${options.token}` } : {})
      }
    });
    return response.data;
  } catch (error) {
    throw authError(error);
  }
}
